/**
 * Text measurement utilities using Canvas API
 * For precise chord placement in leadsheet rendering
 */

let canvas: HTMLCanvasElement | null = null;
let ctx: CanvasRenderingContext2D | null = null;

/**
 * Get or create canvas context for text measurement
 */
function getContext(fontSize: number, fontFamily: string): CanvasRenderingContext2D {
  if (!canvas) {
    canvas = document.createElement('canvas');
  }
  
  if (!ctx) {
    ctx = canvas.getContext('2d');
  }
  
  if (ctx) {
    ctx.font = `${fontSize}px ${fontFamily}`;
  }
  
  return ctx!;
}

/**
 * Measure the width of text
 */
export function measureText(text: string, fontSize: number, fontFamily: string): number {
  const context = getContext(fontSize, fontFamily);
  const metrics = context.measureText(text);
  return metrics.width;
}

/**
 * Calculate pixel position for a character index in text
 */
export function getCharacterPosition(
  text: string,
  charIndex: number,
  fontSize: number,
  fontFamily: string
): number {
  if (charIndex === 0) return 0;
  if (charIndex >= text.length) return measureText(text, fontSize, fontFamily);
  
  const substring = text.substring(0, charIndex);
  return measureText(substring, fontSize, fontFamily);
}

